<div class="snackbar">
	<div class="snackbar__text">
		<span>KWO CONNECT | Livestreams met Pilaar & Hofman</span>
	</div>
	<div class="snackbar__button">
		<button class="btn primary" type="button" (click)="goConnect()">
			<span class="button-text">klik hier</span>

			<span class="button-icon">
				<fa-icon matSuffix [icon]="['fas', 'arrow-right-long']"></fa-icon>
			</span>
		</button>
	</div>

	<span class="snackbar__close" (click)="close()">
		<fa-icon matSuffix [icon]="['fas', 'times']"></fa-icon>
	</span>
</div>